import React from 'react';
import NotfoundSection from '../Components/NotFound';

const NotFoundPage = () => (
  <NotfoundSection />
);

export default NotFoundPage;
